import React, { useEffect, useState } from 'react'
import Header from '../Header'
import firebase from '../../firebase'
import { Grid, Paper, Typography, Card, CardContent, CardActions, Button } from '@material-ui/core';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const customStyles = {
    content: {
        top: '20%',
        left: '8%',
        right: '8%',
        bottom: '20%',
        // marginRight: '-35%',
        // transform: 'translate(-50%, -50%)'
    }
};


export default function Users() {

    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentUser, setCurrentUser] = useState('')
    const [currentUserData, setCurrentUserData] = useState([])
    const db = firebase.firestore();

    const toggleModal = (user) => {
        setModal(!modal)
        setCurrentUser(user)
    }
    const afterOpenModal = () => {

        console.log(currentUser)
        db.collection('Users').doc(currentUser)
            .collection('Orders')
            // .doc('order1')
            .get()
            .then(snapshot => {
                let data = [];
                snapshot.forEach(doc => {
                    data.push(({ ...doc.data(), id: doc.id }));
                })
                console.log(data)
                setCurrentUserData(data)
            })

    }
    useEffect(() => {
        db.collection('Users').doc('6776543210')
            .collection('Orders')
            .doc('order5')
            .set({
                champagne: 3,
                whiskey18: 1,
                whiskeyGlass: 2,
                hotess: 2,
                balance: 0,
                champagneGlass: 1,
                total: 9100

            })
        // db.collection('Users').doc('6776543210')
        //     .set({
        //         name: 'NOKIA',
        //         phoneNo: 6776543210,
        //         orders: 5
        //     })
        return db.collection('Users').onSnapshot((snapshot) => {
            const data = [];
            snapshot.forEach(doc => {
                data.push(({ ...doc.data(), id: doc.id }))

            })


            console.log(data)
            setData(data)
        });

    }, [])
    return (
        <div>
            <Header />
            <Modal
                isOpen={modal}
                onAfterOpen={afterOpenModal}
                onRequestClose={toggleModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <Grid container style={{ marginTop: 10 }}>
                    {currentUserData.map(item => (
                        <Grid item md={3} xs={12} key={item.id}>
                            <Card style={{ textAlign: 'center', minWidth: 275, margin: 10 }}>
                                <CardContent>
                                    <Typography variant="h6" style={{
                                        marginBottom: 10,
                                        fontSize: 22
                                    }} color="textSecondary">
                                        id : {item.id}
                                    </Typography>
                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Champagne : {item.champagne}
                                    </Typography>
                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Whiskey 18 : {item.whiskey18}
                                    </Typography>

                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Champagne Glass : {item.champagneGlass}
                                    </Typography>
                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Whiskey Glass : {item.whiskeyGlass}
                                    </Typography>
                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Hotess : {item.hotess}
                                    </Typography>
                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Total : {item.total}
                                    </Typography>
                                    <Typography style={{
                                        fontSize: 15
                                    }}>
                                        Balance : {item.balance}
                                    </Typography>
                                </CardContent>
                                <CardActions disableSpacing>
                                    <Button
                                        onClick={() => toggleModal(item.id)}
                                        size="small">Close</Button>
                                </CardActions>
                            </Card>
                        </Grid>

                    ))}
                </Grid>

            </Modal>
            <Grid container style={{ marginTop: 10 }}>
                {data.map(item => (
                    <Grid item md={3} xs={12} key={item.name}>
                        <Card style={{ textAlign: 'center', minWidth: 275, margin: 10 }}>
                            <CardContent>
                                <Typography variant="h6" style={{
                                    marginBottom: 10,
                                    fontSize: 22
                                }} color="textSecondary">
                                    Name : {item.name}
                                </Typography>
                                <Typography style={{
                                    fontSize: 15
                                }}>
                                    Phone No : {item.id}
                                </Typography>
                                <Typography style={{
                                    fontSize: 15
                                }}>
                                    Total Orders : {item.orders}
                                </Typography>
                            </CardContent>
                            <CardActions disableSpacing>
                                <Button
                                    onClick={() => toggleModal(item.id)}
                                    size="small">More</Button>
                                <Button
                                    onClick={() => window.open(`https://www.google.com/maps/place/${item.lat},${item.long}`)}
                                    size="small">Location</Button>
                            </CardActions>
                        </Card>
                    </Grid>

                ))}
            </Grid>
        </div>
    )
}
